import React, { useEffect } from "react";
import { X } from "lucide-react";

const NAVY = "#1C4E80";
const CORAL = "#EA6A47";
const SLATE = "#5A6B75";

const QUOTES = [
  {
    text: "The ease and flexibility of uReserve's interactive planning tool combined with HOA domain experience allowed our board to thoughtfully develop a reasoned reserve strategy.",
    who: "Kevin Reiss",
    role: "President, Voyageurs Retreat Community Association",
    members: 195,
  },
  {
    text: "uReserve is dialed in and amazing - the planning flexibility and \u201cwhat if\u201d visibility greatly helps us better understand and communicate the reserve budget to our community. I can't imagine doing reserve planning without a tool like this. You have built a highly capable solution that can save thousands of HOA's from future financial heartache.",
    who: "Jeff O\u2019Dell",
    role: "Treasurer, Wyer Hill Condominium Association",
    members: 25,
  },
  {
    text: "uReserve is an intuitive platform that helps our HOA understand what our future financial needs will be. It allows us to be proactive in managing our reserve funds, while remaining compliant too. It also provides helpful information for us to share with our residents, so they are aware of what the reserve funds are for.",
    who: "Chris DuFresne",
    role: "President, Adelaide Landing Master Association",
    members: 315,
  },
];

export default function TestimonialsModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: "rgba(15, 42, 68, 0.45)" }}
      onClick={onClose}
      data-testid="testimonials-modal"
    >
      <div
        className="relative bg-white rounded-[6px] w-full max-w-[720px] max-h-[88vh] overflow-y-auto shadow-xl"
        style={{ border: `1px solid ${NAVY}`, fontFamily: "'Source Sans 3', sans-serif" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 p-1 rounded hover:bg-slate-100 transition-colors"
          aria-label="Close"
          data-testid="testimonials-close"
        >
          <X size={18} color={NAVY} />
        </button>
        <div className="px-8 pt-8 pb-8">
          <div style={{ fontSize: 11, letterSpacing: ".14em", textTransform: "uppercase", fontWeight: 600, color: SLATE }}>
            In their words
          </div>
          <div style={{ marginTop: 6, fontSize: 26, lineHeight: 1.15, color: NAVY, fontWeight: 700 }}>
            What <span style={{ color: CORAL, fontStyle: "italic" }}>Early Adopters</span> Are Saying
          </div>
          <div className="flex flex-col gap-7 mt-6">
            {QUOTES.map((q, i) => (
              <figure key={q.who} style={{ margin: 0 }} data-testid={`testimonial-${i + 1}`}>
                <blockquote
                  style={{ margin: 0, paddingLeft: 14, borderLeft: `3px solid ${CORAL}`, fontStyle: "italic", fontSize: 15, lineHeight: 1.55, color: "#1A1A1A" }}
                >
                  {q.text}
                </blockquote>
                <figcaption style={{ marginTop: 8, textAlign: "right", fontSize: 13.5, color: NAVY }}>
                  &mdash; <strong>{q.who}</strong>, {q.role}, {q.members} Members
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
